import { Component, inject, OnDestroy, OnInit } from '@angular/core'
import { PageHeaderComponent, PageHeaderMenuItem } from '../page-header/page-header.component'
import { PageContentComponent } from '../page-content/page-content.component'
import { RLSCertsTableComponent } from '../table/rls-certs-table.component'
import { MatMenuModule } from '@angular/material/menu'
import { RLSCertUploadModal } from '../modals/rls-cert-upload-modal/rls-cert-upload-modal.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Router, ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs'
import { FilterService } from 'src/app/shared/services/filter/filter.service'
import { Location } from '@angular/common'
import { filterGroup } from '../table/definitions/rls-certs-column-definition'
import { StringFilter } from 'src/app/shared/services/filter/string-filter'
import { DateRangeFilter } from 'src/app/shared/services/filter/date-range-filter'

@Component({
  selector: 'app-rls-certificates',
  imports: [
    MatMenuModule,
    PageHeaderComponent,
    PageContentComponent,
    RLSCertsTableComponent,
  ],
  styles: '',
  template: `
    <div app-page-header header="Digital Certificates" [menuItems]="pageHeaderMenuItems"></div>
    <app-page-content>
      <app-rls-certs-table />
    </app-page-content>`,
})
export class RLSCertificatesComponent implements OnInit, OnDestroy {
  private modalService = inject(NgbModal)
  private filterService = inject(FilterService)
  private router = inject(Router)
  private route = inject(ActivatedRoute)
  private location = inject(Location)

  private subscription = new Subscription()

  protected readonly pageHeaderMenuItems: readonly PageHeaderMenuItem[] = [
    { label: 'Upload', onClick: () => this.onUploadAction() },
  ]

  async ngOnInit(): Promise<void> {
    const { dispatch } = this.filterService
    dispatch(FilterService.InitFiltersAction({
      fieldGroup: filterGroup,
      fields: {
        participant: new StringFilter({
          config: {
            allowMultiple: true,
            meta: {
              fieldGroup: filterGroup,
              fieldName: 'participant',
              fieldDisplay: 'Market Participant',
            },
          },
        }, dispatch),
        participant_name: new StringFilter({
          config: {
            allowMultiple: true,
            meta: {
              fieldGroup: filterGroup,
              fieldName: 'participant_name',
              fieldDisplay: 'Name',
            },
          },
        }, dispatch),
        start_date: new DateRangeFilter({
          config: {
            showOperation: true,
            showRange: true,
            showTime: false,
            showSeconds: false,
            meta: {
              fieldGroup: filterGroup,
              fieldName: 'start_date',
              fieldDisplay: 'Start Date',
            },
          },
        }, dispatch),
        end_date: new DateRangeFilter({
          config: {
            showOperation: true,
            showRange: true,
            showTime: false,
            showSeconds: false,
            meta: {
              fieldGroup: filterGroup,
              fieldName: 'start_date',
              fieldDisplay: 'Start Date',
            },
          },
        }, dispatch),
      },
    }))
    this.subscription.add(
      (await this.filterService.manageQueryParms(this.router, this.route, this.location, filterGroup))
        .subscribe(),
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  onUploadAction() {
    this.modalService.open(RLSCertUploadModal, { centered: true })
  }
}
